import React, { FC } from 'react';
import styled from 'styled-components';
import media from '../../constants/media';
import { IVerticalLinkCards } from '../../interfaces/umbracoNodes/contentSlices';
import { ContentContainer } from '../base/contentContainer/contentContainer';
import { Column, Columns } from '../base/grid';
import { RichText } from '../base/richText/richText';
import RichTextTitle from '../base/richTextTitle';
import LinkCard from '../cards/linkCard';

const Root = styled.div`
	margin-top: 150px;
`;

const Description = styled(RichText)`
	margin-top: 24px;
`;

const TextBlock = styled.div`
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`;

const ColumnsWrapper = styled.div`
	display: flex;
	flex-direction: column;

	${media.desktopSmall`
		flex-direction: row;
		justify-content: space-between;
	`}
`;

const TextColumns = styled(Columns)`
	${media.desktopSmall`
		width: calc(125% / 3 + 1.5rem);
	`}
`;

const ContentColumns = styled(Columns)`
	margin-block: 56px -3rem;

	${media.desktopSmall`
		margin-block: 0 -3rem;
		width: calc(50% + 1.5rem);
	`}
`;

const ColumnStyled = styled(Column)`
	display: flex;
	margin-bottom: 3rem;
`;

interface Props {
	content: IVerticalLinkCards;
}

const VerticalLinkCards: FC<Props> = ({ content }) => {
	return (
		<Root>
			<ContentContainer>
				<ColumnsWrapper>
					<TextColumns>
						<Column marginBottom={0}>
							<TextBlock>
								<RichTextTitle content={content.Values.Title} type="h3" />
								<Description content={content.Values.Description} />
							</TextBlock>
						</Column>
					</TextColumns>
					<ContentColumns>
						{content.Values.Cards.map((card, idx) => (
							<ColumnStyled key={idx} tablet={1 / 2} desktopSmall={1}>
								<LinkCard content={card} />
							</ColumnStyled>
						))}
					</ContentColumns>
				</ColumnsWrapper>
			</ContentContainer>
		</Root>
	);
};

export default VerticalLinkCards;
